import { render, staticRenderFns } from "./InventoryWidgetGraph.vue?vue&type=template&id=1c673d66&scoped=true&"
import script from "./InventoryWidgetGraph.vue?vue&type=script&lang=ts&"
export * from "./InventoryWidgetGraph.vue?vue&type=script&lang=ts&"
import style0 from "./InventoryWidgetGraph.vue?vue&type=style&index=0&id=1c673d66&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c673d66",
  null
  
)

export default component.exports